if (!customElements.get('aleisha-product-guides')) {
  customElements.define(
    'aleisha-product-guides',
    class AleishaProductGuides extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('[data-size-chart-dialog]');
        this.openButton = this.querySelector('[data-size-chart-open]');
        this.closeButton = this.querySelector('[data-size-chart-close]');

        this.openButton?.addEventListener('click', () => this.open());
        this.closeButton?.addEventListener('click', () => this.close());
        this.dialog?.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.close();
        });
      }

      open() {
        if (!this.dialog) return;
        if (typeof this.dialog.showModal === 'function') this.dialog.showModal();
        else this.dialog.setAttribute('open', '');
        document.documentElement.classList.add('aleisha-guide-open');
      }

      close() {
        if (!this.dialog) return;
        if (typeof this.dialog.close === 'function') this.dialog.close();
        else this.dialog.removeAttribute('open');
        document.documentElement.classList.remove('aleisha-guide-open');
        this.openButton?.focus();
      }
    }
  );
}

